import { render, staticRenderFns } from "./basics.vue?vue&type=template&id=602a08e2&scoped=true&"
import script from "./basics.vue?vue&type=script&lang=js&"
export * from "./basics.vue?vue&type=script&lang=js&"
import style0 from "./basics.vue?vue&type=style&index=0&id=602a08e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602a08e2",
  null
  
)

export default component.exports